export default "__VITE_ASSET__DmOjK04V__"